import SoneIcon from './component'

export default SoneIcon
